<template>
    <div class="table-responsive">
        <table class="table table-sm table-bordered table-striped bg-white my-0">
            <thead>
                <tr>
                    <th class="text-left w-200-px">
                        {{ $t('logs.headers.date') }}
                    </th>
                    <th>{{ $t('logs.headers.messages') }}</th>
                    <th class="w-175-px">
                        {{ $t('logs.headers.users') }}
                    </th>
                </tr>
            </thead>

            <tbody v-if="isEmpty">
                <tr>
                    <td class="text-center text-muted" colspan="3">
                        <LoadingLabel v-if="isLoading" key="loading-label" is-loading />

                        <em v-else key="empty-label">
                            {{ $t('logs.empty') }}
                        </em>
                    </td>
                </tr>
            </tbody>

            <tbody v-else>
                <LogRow v-for="log in logs" :key="log.id" :log="log" />
            </tbody>
        </table>
    </div>
</template>

<script>
import LoadingLabel from '@/js/components/common/labels/LoadingLabel';
import LogRow from '@/js/components/log/LogRow';

export default {
    name: 'LogsTable',

    components: {LoadingLabel, LogRow},

    props: {
        logs: {type: Array, required: true},
        isLoading: {type: Boolean},
    },

    computed: {
        isEmpty() {
            return this.logs.length === 0;
        },
    },
};
</script>
